var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-stripe",style:({
        color: _vm.textColor,
        backgroundColor: _vm.backgroundColor,
    })},[_c('Icon',{attrs:{"isLocal":"","height":"32px","width":"auto","iconSource":"bulb","fill":_vm.textColor}}),_c('div',{staticClass:"tip-stripe__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }